import { Forward, Reply } from "lucide-react";

type Props = {
  disabled?: boolean;
  onReply: () => void;
  onForward: () => void;
};

/** Pied lecteur mobile — deux gros boutons, le reste est dans le menu ⋯. */
export function MobileReaderActionBar({ disabled = false, onReply, onForward }: Props) {
  return (
    <div className="mobile-reader-action-bar" role="toolbar" aria-label="Répondre ou transférer">
      <button
        type="button"
        className="mobile-reader-action-bar__btn mobile-reader-action-bar__btn--primary"
        disabled={disabled}
        onClick={onReply}
      >
        <Reply className="h-5 w-5 shrink-0" aria-hidden />
        Répondre
      </button>
      <button
        type="button"
        className="mobile-reader-action-bar__btn mobile-reader-action-bar__btn--secondary"
        disabled={disabled}
        onClick={onForward}
      >
        <Forward className="h-5 w-5 shrink-0" aria-hidden />
        Transférer
      </button>
    </div>
  );
}
